"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WorkerMode = void 0;
const mithril_1 = __importDefault(require("mithril"));
const contract_print_1 = require("../components/contract/contract_print");
const user_conditions_print_1 = require("../components/contract/user_conditions_print");
const invoice_print_1 = require("../components/invoice/invoice_print");
const main_1 = require("../main");
const nav_1 = require("../nav");
const admin_index_page_1 = require("../pages/admin_index_page");
const announces_index_page_1 = require("../pages/announces_index_page");
const audit_page_1 = require("../pages/audit_page");
const booking_calendar_page_1 = require("../pages/booking_calendar_page");
const change_password_page_1 = require("../pages/change_password_page");
const client_index_page_1 = require("../pages/client_index_page");
const commercial_offer_index_page_1 = require("../pages/commercial_offer_index_page");
const contract_index_page_1 = require("../pages/contract_index_page");
const forgot_password_page_1 = require("../pages/forgot_password_page");
const notes_page_1 = require("../pages/notes_page");
const options_page_1 = require("../pages/options_page");
const payments_index_page_1 = require("../pages/payments_index_page");
const rooms_index_page_1 = require("../pages/rooms_index_page");
const sign_in_1 = require("../pages/sign_in");
const turnover_page_1 = require("../pages/turnover_page");
const venues_index_page_1 = require("../pages/venues_index_page");
exports.WorkerMode = {
    routes: {
        "/sign-in": sign_in_1.SignIn,
        "/forgot-password": forgot_password_page_1.ForgotPasswordPage,
        "/reset-password/:email/:token": change_password_page_1.ChangePasswordPage,
        "/calendar/bookings&:opts...": (0, main_1.MainLayout)(booking_calendar_page_1.BookingCalendarPage),
        "/calendar/payments&:opts...": (0, main_1.MainLayout)(payments_index_page_1.PaymentsIndexPage),
        "/calendar/notes&:opts...": (0, main_1.MainLayout)(notes_page_1.NotesPage),
        "/commercial_offers&:opts...": (0, main_1.MainLayout)(commercial_offer_index_page_1.CommercialOfferIndexPage),
        "/&:opts...": (0, main_1.MainLayout)(booking_calendar_page_1.BookingCalendarPage),
        "/clients&:opts...": (0, main_1.MainLayout)(client_index_page_1.ClientIndexPage),
        "/admins&:opts...": (0, main_1.MainLayout)(admin_index_page_1.AdminIndexPage),
        "/contracts&:opts...": (0, main_1.MainLayout)(contract_index_page_1.ContractIndexPage),
        "/audit&:opts...": (0, main_1.MainLayout)(audit_page_1.AuditPage),
        "/venues&:opts...": (0, main_1.MainLayout)(venues_index_page_1.VenuesIndexPage),
        "/rooms&:opts...": (0, main_1.MainLayout)(rooms_index_page_1.RoomsIndexPage),
        "/announces&:opts...": (0, main_1.MainLayout)(announces_index_page_1.AnnouncesIndexPage),
        "/invoices/:invoice_id/print": invoice_print_1.InvoicePrint,
        "/contracts/:contract_id/print": contract_print_1.ContractPrint,
        "/clients/:client_id/print": user_conditions_print_1.UserConditionsPrint,
        "/financial/turnover&:opts...": (0, main_1.MainLayout)(turnover_page_1.TurnoverPage),
        "/options&:opts...": (0, main_1.MainLayout)(options_page_1.OptionsPage)
    },
    nav() {
        return (0, mithril_1.default)("aside.menu", (0, mithril_1.default)("hr"), (0, mithril_1.default)("ul.menu-list", [
            (0, mithril_1.default)("p.menu-label", "Calendrier"),
            (0, mithril_1.default)((0, nav_1.ni)("#/calendar/bookings&", "Réservations", "fa-calendar-day")),
            (0, mithril_1.default)((0, nav_1.ni)("#/calendar/payments&", "Paiements", "fa-file-invoice-dollar")),
            (0, mithril_1.default)((0, nav_1.ni)("#/calendar/notes&", "Notes", "fa-sticky-note")),
            (0, mithril_1.default)("p.menu-label", "Ressources"),
            (0, mithril_1.default)("li", (0, mithril_1.default)((0, nav_1.ni)("#/clients&", "Clients", "fa-id-card-alt")), (0, mithril_1.default)((0, nav_1.ni)("#/contracts&", "Forfaits", "fa-file-contract")), (0, mithril_1.default)((0, nav_1.ni)("#/announces&", "Annonces", "fa-bell"))),
            (0, mithril_1.default)("p.menu-label", "Monitoring"),
            (0, mithril_1.default)("li", (0, mithril_1.default)((0, nav_1.ni)("#/audit&", "Historique", "fa-clock")))
        ]));
    }
};
